"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var $ = require("jquery");
var numeral = require("numeral");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var LikeButtonComponent = (function (_super) {
    __extends(LikeButtonComponent, _super);
    function LikeButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.voteId = ko.observable();
        this.numeral = numeral;
        this.isLiked = ko.pureComputed(function () {
            return !!_this.voteId();
        });
        this.title = ko.pureComputed(function () {
            return _this.isLiked() ? "Не понравилось" : "Понравилось";
        });
        this.likeCount = ko.observable();
        this.targetId = params.targetId;
        this.type = params.type;
        this.disabled = params.disabled;
        this.voteId(params.voteId);
        this.likeCount(params.likeCount);
        var $siblings = $(element).siblings();
        this.$btn = $siblings.filter(".btn-like");
        this.$heart = $siblings.find(".heart");
        this.$heartContainer = $siblings.find(".heart-container");
    }
    LikeButtonComponent.prototype.toggleLike = function () {
        var _this = this;
        if (this.disabled)
            return;
        if (this.$btn.attr("disabled"))
            return;
        this.$btn.attr("disabled", "disabled");
        if (this.isLiked()) {
            this.$heart.removeClass("heart-animation");
            this.$btn.addClass("hover-state-canceled");
            this.$btn.on("mouseleave", function () {
                _this.$btn.removeClass("hover-state-canceled");
                _this.$btn.off("mouseleave");
            });
        }
        else {
            this.$heartContainer.css({ overflow: "visible" });
            this.$btn.removeClass("hover-state-canceled");
            this.$heart.addClass("heart-animation");
            setTimeout(function () {
                _this.$heartContainer.css({ overflow: "hidden" });
            }, 800);
        }
        var url = "";
        switch (this.type) {
            case "Work":
                url = "work/like";
                break;
            case "Collection":
                url = "collection/like";
                break;
            case "Art":
                url = "art/like";
                break;
            default:
                alert("LikeButton error. Unknown type.");
                break;
        }
        ajaxUtils_1.AjaxUtils.post(url, {
            targetId: this.targetId,
            isLiked: !this.isLiked(),
            voteId: this.voteId()
        }).done(function (result) {
            if (result.isSuccessful) {
                _this.voteId(result.data.voteId);
                _this.likeCount(result.data.likeCount);
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            _this.$btn.removeAttr("disabled");
            if (_this.type == "Work") {
                _this.handleRefreshWorkMetaInfo(app, _this.targetId);
            }
        });
    };
    return LikeButtonComponent;
}(baseComponent_1.default));
ko.components.register("like-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LikeButtonComponent;
//# sourceMappingURL=likeButton.js.map